import { createI18n } from "vue-i18n";

// Translations
const translations = {
  en: require('@/translations/en.json'),
  fr: require('@/translations/fr.json')
}

export const i18n = createI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: translations
});
